// faq tabs toggal start

      function togal_tabs (item) {
        item.addEventListener("click", () => {
           toggal_all_tabs(item.getAttribute('data-faq_content'));
        });        
      }
        function toggal_all_tabs(tabs_data){
                let tabs_button = document.querySelectorAll("[data-faq_content]");
                            tabs_button.forEach(b => {
                              if(b.getAttribute('data-faq_content') == tabs_data){
                                if(b.classList.contains('is_open')){
                                   b.classList.remove("is_open");    
                                  }else{
                                   b.classList.add("is_open");
                                  }
                              }else{
                                 b.classList.remove("is_open");
                              }
                              });
                           
              }
function faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
      tabs_title.forEach(togal_tabs);
}
      faq_taggol();


// faq tabs toggal end


// faq tabs toggal content start
      function tab_mai_mappert(item) {
        item.addEventListener("click", () => {
           toggal_all_tabs_content(item.getAttribute('data-hendles'));
        });        
      }
        function toggal_all_tabs_content(tabs_data){
                let tabs_content_toggel = document.querySelectorAll("[data-hendles]");
                            tabs_content_toggel.forEach(b => {
                              if(b.getAttribute('data-hendles') == tabs_data){
                                   b.classList.add("active");
                                  document.querySelector(b.getAttribute('data-hendles')).style.display = 'block';
                              }else{
                                 b.classList.remove("active");
                                 document.querySelector(b.getAttribute('data-hendles')).style.display = 'none';
                              }
                              });
                           
              }
      let tabs_content  = document.querySelectorAll("[data-hendles]");
      tabs_content.forEach(tab_mai_mappert);
// faq tabs toggal content end


     // Add this code make menu appears image hover
      function bindMouseOverToMegaMenu_images (item) {
        item.addEventListener("mouseover", () => {
           image_hide(item.getAttribute('data-image-name'));
          let image = document.querySelector(".header__inline-menu").querySelector("img.col_image")
          item.addEventListener("mouseleave", () => {
            image_hide();
          });
        });
      }
        function image_hide(imag){
             let images_val = document.querySelector(".header__inline-menu").querySelectorAll("img.col_image");
              images_val.forEach(b => {
              if(b.alt == imag){
                b.classList.remove("hidden");
              }else{
                b.classList.add("hidden");
              }
                });
          }
    let main_images = document.querySelector(".header__inline-menu");
    if(main_images){
      let images = main_images.querySelectorAll("[data-image-name]");
      images.forEach(bindMouseOverToMegaMenu_images);
    }
$(document).ready(function(){

    $("#sorting-dropdown").change(function() {
      var selectedOption = $(this).val();
      sortBlogPosts(selectedOption);
    });

    function sortBlogPosts(option) {
      var postsContainer = $(".blog-articles");
      var posts = postsContainer.children(".cust_sort_blog");

      switch (option) {
        case "title-ascending":
          posts.sort(function(a, b) {
            return $(a).find(".blog-post-title").text().localeCompare($(b).find(".blog-post-title").text());
          });
          break;
        case "title-descending":
          posts.sort(function(a, b) {
            return $(b).find(".blog-post-title").text().localeCompare($(a).find(".blog-post-title").text());
          });
          break;
        case "created-ascending":
          posts.sort(function(a, b) {
            var dateA = new Date($(a).find(".blog-post-date").text());
            var dateB = new Date($(b).find(".blog-post-date").text());
            return dateA - dateB;
          });
          break;
        case "created-descending":
          posts.sort(function(a, b) {
            var dateA = new Date($(a).find(".blog-post-date").text());
            var dateB = new Date($(b).find(".blog-post-date").text());
            return dateB - dateA;
          });
          break;
        default:
          // No sorting, maintain original order
          break;
      }

      postsContainer.empty().append(posts);
    }
  
});

// Recommendation Blog Slider Js
var init = false;
var swiper;
function swiperCard() {
  if (window.innerWidth <= 767) {
    if (!init) {
      init = true;
      swiper = new Swiper(".recommendation_blog_slider", {
        slidesPerView: 1.4,
        spaceBetween: 20,
        centeredSlides: true,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
          draggable: true,
        },
        breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 30,
        }
      },
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);

// Collection Filter Toggleclass JS
if ($(window).width() > 750) {
$('.facets__heading').click(function(){
  $(this).toggleClass('filter_active');
   $('#FacetsWrapperDesktop').toggleClass('dd_cm_filter');
});
}

if ($(window).width() < 750) {
$('.facets__heading').click(function(){
  $('.mobile-facets__open-wrapper').click();
});
}
